<template>
  <div class="news-header__container">
    <div>
      <div class="news-header__title">
        <div class="news-header__title-text">
          {{ title }}
        </div>
        <div class="news-header__title-number">
          {{ number }}
        </div>
      </div>
      <div class="pt-2 hidden sm:block">
        //////////////////////////////////////////////////////////////////
      </div>
    </div>
    <div class="has-border hidden xxl:block">
      <div class="news-header__random-numbers">
        <span>[01-9P]</span>
        <span>1D2.2X</span>
        <span>[110423]</span>
        <span>B12.23</span>
      </div>
      <div class="news-header__random-numbers">
        <span>[24-567]</span>
        <span>345605</span>
        <span>[24-567]</span>
        <span>345605</span>
      </div>
      <div class="news-header__random-numbers">
        <span>[VC-99]</span>
        <span>212.63</span>
        <span>[9-3345]</span>
        <span>12X23T</span>
      </div>
    </div>
    <div class="has-border hidden lg:block">
      <div class="news-header__random-numbers">
        PROG KIT 56-0948-8872643 REB {{ username }}
      </div>
      <div class="news-header__random-numbers">
        345.38382 - {PEID} - 383DFXC122PS
      </div>
      <div class="pl-4">
        <span class="mr-6">///////////////</span>
        <span>///////////////</span>
      </div>
    </div>
    <div class="flex absolute pin-r mr-4">
      <div
        v-if="$route.params.enableBack"
        class="h-8 w-8 bg-blue-darker border border-blue mr-2 flex justify-center items-center text-2xl cursor-pointer"
        @click="$router.go(-1)"
      >
        &lt;
      </div>
      <div
        class="h-8 w-8 bg-blue-darker border border-blue flex justify-center items-center text-2xl cursor-pointer"
        @click="$router.push('/')"
      >
        X
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SectionLayoutHeader',

  props: {
    title: {
      type: String,
      required: true,
    },

    number: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      username: 'auth/username',
    }),
  },
}
</script>

<style lang="postcss" scoped>
.news-header {
  &__container {
    font-family: 'input-mono';
    font-size: 12px;
    @apply flex p-2 text-blue;
  }

  &__title {
    @apply flex flex-1 items-center;

    &-text {
      font-family: 'univia-pro';
      font-size: 24px;
      @apply text-blue-lighter bg-blue p-1;
    }

    &-number {
      font-family: 'input-mono';
      font-size: 18px;
      font-weight: 300;
      @apply text-blue ml-2 hidden;
    }
  }

  &__random-numbers {
    @apply flex justify-between px-4 py-px whitespace-no-wrap;
  }
}

.has-border {
  @apply border-l border-blue pr-4 ml-4;
}

@screen sm {
  .news-header {
    &-number {
      @apply block;
    }
  }
}
</style>
